import { Tab, Tabs } from "@mui/material";
import type { StatisticsView } from "./types";

const tabs: Array<{ value: StatisticsView; label: string }> = [
  { value: "overview", label: "Overview" },
  { value: "trends", label: "Trends" },
  { value: "categories", label: "Categories" },
  { value: "payees", label: "Payees" },
  { value: "accounts", label: "Accounts" },
];

export function StatisticsTabs({ value, onChange }: { value: StatisticsView; onChange: (view: StatisticsView) => void }) {
  return (
    <Tabs className="statistics-tabs" value={value} onChange={(_, next: StatisticsView) => onChange(next)} variant="scrollable" scrollButtons="auto" aria-label="Statistics views">
      {tabs.map((tab) => <Tab key={tab.value} value={tab.value} label={tab.label} />)}
    </Tabs>
  );
}
